import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import UserDetailsScreen from './components/screen-user-details';
import CompanyDetailsScreen from './components/screen-company-details';
import ConfirmationDetailsScreen from './components/screen-confirmation-details';
import AddTeamScreen from './components/screen-add-team';
import CompaniesApi from "../../lib/companies/companies-api";

import AlertManager from '../../managers/alert/alert-manager';

export const USER_DETAILS_SCREEN = 'user-details-screen';
export const COMPANY_DETAILS_SCREEN = 'company-details-screen';
export const CONFIRMATION_DETAILS_SCREEN = 'confirmation-details-screen';
export const ADD_TEAM_SCREEN = 'add-team-screen';


class CreateAccount extends Component {

    constructor(props) {
        super(props);

        this.state = {
            screen: USER_DETAILS_SCREEN,
            values: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                company_industry_id : '',
                company_name: '',
                company_number: '',
                company_type: '',
                company_employees: '',
                company_owner: '',
                details_confirmation: false,
                details_agree_terms: false,
                team_add: [],
                team_email: '',
                team_role: ''
            },
            industries : []
        };
    }

    handleChange(name, value, callback) {
        this.setState({
            values: Object.assign({}, this.state.values, {
                [name] : value
            })
        }, () => {

            if (callback) callback()
        })
    }

    handleObjectChange(obj) {
        this.setState({
            values: Object.assign({}, this.state.values, obj)
        }, () => console.log(this.state.values))
    }

    componentDidMount() {
        this.getIndustries();
    }

    login(email, password) {
        axios.post('/api/auth', {email, password}).then(() => {
            window.location = '/myeb/dashboard?welcome=true';
        }).catch(() => {
            AlertManager.error('We could not log you in. Please visit /login and attempt to login');
        });
    }

    getIndustries() {
        CompaniesApi.getIndustries(1, 1000).then(data => {
            this.setState({industries: data.data});
        });
    }


    render() {
        return (
            <>
                {
                    this.state.screen === USER_DETAILS_SCREEN &&
                    <UserDetailsScreen onNext={() => this.setState({screen: COMPANY_DETAILS_SCREEN})} values={this.state.values} onChange={this.handleChange.bind(this)}/>
                }
                {
                    this.state.screen === COMPANY_DETAILS_SCREEN &&
                    <CompanyDetailsScreen
                        industries={this.state.industries}
                        onNext={() => this.setState({screen: ADD_TEAM_SCREEN})}
                        onBack={() => this.setState({screen: USER_DETAILS_SCREEN})}
                        values={this.state.values}
                        onChange={this.handleChange.bind(this)}
                        handleObjectChange={this.handleObjectChange.bind(this)}/>
                }
                {
                    this.state.screen === ADD_TEAM_SCREEN &&
                    <AddTeamScreen
                        onNext={() => this.setState({screen: CONFIRMATION_DETAILS_SCREEN})}
                        onBack={() => this.setState({screen: COMPANY_DETAILS_SCREEN})}
                        values={this.state.values} onChange={this.handleChange.bind(this)}/>
                }
                {
                    this.state.screen === CONFIRMATION_DETAILS_SCREEN &&
                    <ConfirmationDetailsScreen
                        industries={this.state.industries}
                        onBack={() => this.setState({screen: USER_DETAILS_SCREEN})}
                        onComplete={this.login.bind(this)}
                    values={this.state.values} onChange={this.handleChange.bind(this)} />
                }
            </>
        );
    }
}

export default CreateAccount;

const el = document.getElementById('register-component');

if (el) {
    ReactDOM.render(<CreateAccount/>, el);
}
